import React from 'react'
import { any } from 'prop-types'

const RatingStars = props => {
	const { rating } = props

	return (
		<div
			className="rating-stars"
			style={{ '--rating': rating }}
			title={'This provider is rated ' + rating + ' out of 5.'}
			aria-label={'This provider is rated ' + rating + ' out of 5.'}
		>
			<div className="star">
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="22"
					height="21"
					viewBox="0 0 22 21"
					fill="none"
				>
					<path
						d="M10.7951 0.922464C10.7615 0.819602 10.6656 0.75 10.5574 0.75C10.4492 0.75 10.3533 0.819602 10.3198 0.922464L8.00913 8.00532H0.531114C0.422719 8.00532 0.326673 8.07517 0.293276 8.17829C0.259879 8.28142 0.296739 8.39431 0.384554 8.45786L6.43353 12.8351L4.12315 19.9171C4.08957 20.0201 4.12607 20.1329 4.21357 20.1967C4.30106 20.2605 4.41967 20.2607 4.50739 20.1972L10.5574 15.8192L16.6075 20.1972C16.6952 20.2607 16.8138 20.2605 16.9013 20.1967C16.9888 20.1329 17.0253 20.0201 16.9917 19.9171L14.6813 12.8351L20.7303 8.45786C20.8181 8.39431 20.855 8.28142 20.8216 8.17829C20.7882 8.07517 20.6921 8.00532 20.5838 8.00532H13.1057L10.7951 0.922464Z"
						fill="#00A9CE"
						stroke="#00A9CE"
						strokeWidth="0.5"
						strokeLinejoin="round"
					/>
				</svg>
			</div>
		</div>
	)
}

RatingStars.propTypes = {
	rating: any.isRequired,
}

export default RatingStars
